// extracted by mini-css-extract-plugin
module.exports = {"containerStlUpload":"StlUpload_containerStlUpload__2so-R"};